<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        {{ $t('sheet.sheet_components.close_inventory.title') }}
    </th>
    <template v-for="day in inventory">
        <td class="sheet-cell pa-0 text-center">
            <v-progress-circular v-if="loading_date == day.date" size="12" width="2" indeterminate />
            <v-icon v-else large v-text="day.close_out ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="day.close_out ? 'red' : 'grey darken-1'" @click="day.close_out = !day.close_out; save(day)" />
        </td>
    </template>
</tr>
</template>
<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        inventory: [Array, Object],
        params: [Array, Object],
        backup_sheet: [Object, Array],
    },
    data() {
        return {
            loading_date: null
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        save(day) {
            this.loading_date = day.date;
            let inventory = {};
            inventory[day.room_type_id] = {};
            inventory[day.room_type_id][day.date] = {
                close_out: day.close_out
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.inventory = inventory;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';

            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.inventory[day.room_type_id][day.date].close_out = day.close_out;
                })
                .catch(error => {
                    this.inventory[day.date].close_out = !day.close_out;
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date = null;
                });
        }
    }
}
</script>
